import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { FirestoreService } from 'src/app/services/service.index';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {


  //'id',
  //'location'
  displayedColumns: string[] = [  'company', 'firstname', 'lastname', 'identification', 'address', 'houropen', 'hourclose', 'status', 'actions'];

  dataSource = new MatTableDataSource();

  user:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private afs: FirestoreService) { }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.afs.getAllCustomerByCompany(this.user.companyId).subscribe(customer => {

       this.dataSource.data = customer;


    });
  }

  ngAfterViewInit(){
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(sort: Sort) {
    //const data = ELEMENT_DATA.slice();
    if (!sort.active || sort.direction === '') {
      //this.sortedData = data;
      return;
    }
 }

 deleteCustomer(customer){
  //console.log(user);


    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
            this.afs
              .deleteCustomer(this.user.companyId, customer.id)
              .then((resp: any) => {

                Swal.fire('Good job!', 'Customer has been deleted', 'success');
              })
              .catch((error) => {
                console.log(error);
              });
      }
    });

}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  statusCustomer(status){
    if(status == 0){
        return "Inactive";
    }else if(status == 1){
      return "Active";
  }
 }

 getColorStatus(status){

  if(status == 0){
      return '#e74c3c'
  }else if(status ==1){
     return '#27ae60'
  }

}


}
